import { brand, channelGroups, sitemapGroups } from "@/mocks/homeData";

export default function SiteMapSection() {
  return (
    <section id="sitemap" className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 font-label text-xs text-accent-400 tracking-widest">
            <i className="ri-guide-line" />
            SITEMAP
          </span>
          <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-background-50">
            站点地图：一次看完全部入口
          </h2>
          <p className="mt-4 font-body text-sm md:text-base text-background-200/85 leading-relaxed">
            如果你不想逐条翻阅，这里把所有栏目按用途归类列出，点击任意一项即可跳转到对应板块。
            建议收藏本页，作为查找入口的起点。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {sitemapGroups.map((group) => (
            <div key={group.title}>
              <h3 className="font-label text-sm font-bold text-accent-300 mb-4 pb-3 border-b border-foreground-800">
                {group.title}
              </h3>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={`${group.title}-${link.label}`}>
                    <a
                      href={link.href}
                      className="group inline-flex items-center gap-2 font-body text-sm text-background-200/80 hover:text-accent-200 cursor-pointer transition-colors"
                    >
                      <span className="w-4 h-4 flex items-center justify-center text-foreground-500 group-hover:text-accent-400 transition-colors">
                        <i className="ri-arrow-right-s-line text-base" />
                      </span>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-lg border border-foreground-800 bg-foreground-900 p-6 md:p-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <h3 className="font-heading font-bold text-lg text-background-50">
                频道结构总览
              </h3>
              <p className="mt-2 font-body text-sm text-background-200/75">
                {brand.name} 目前共设 {channelGroups.length} 个板块、{channelGroups.reduce((sum, g) => sum + g.channels.length, 0)} 个内容频道。
              </p>
            </div>
            <a
              href="#channels"
              className="whitespace-nowrap self-start cursor-pointer font-label text-sm px-5 py-2.5 rounded-md bg-accent-500 text-secondary-950 hover:bg-accent-400 transition-colors"
            >
              返回频道导览
            </a>
          </div>
          <div className="mt-6 flex flex-wrap gap-2">
            {channelGroups.map((group) => (
              <a
                key={group.id}
                href="#channels"
                className="inline-flex items-center gap-2 font-label text-xs px-3.5 py-2 rounded-full bg-foreground-800 text-background-100 hover:bg-accent-500 hover:text-secondary-950 cursor-pointer transition-colors"
              >
                <i className={group.icon} />
                {group.title}
                <span className="text-[10px] opacity-70">{group.channels.length}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}